import React, { Component } from 'react';
import './hsiTitle.css';
import {API} from 'aws-amplify';

class HsiTitle extends Component {

  state = {
    scoreCounts: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    pageToChoose: 1
  };

  componentDidMount() {
    setTimeout(() => {
      const scoreCounts = [];
      let currScore = 0;
      let allScore = this.state.scoreCounts.length;
      this.state.scoreCounts.forEach((unused, i) => {
        this.queryCountScore(i)
        .then(res => {
          // console.log(res)
          scoreCounts[i] = res;
          currScore++;
          // console.log(scoreCounts)
          if (currScore === allScore) this.setState({scoreCounts});
        })
        .catch(err => {
          console.log(err);
        });
      });
    }, 0);
  };

    queryCountScore = (score, ExclusiveStartKey) => {
      // console.log(score)
      return API.get('HSI', '/queryscore', {queryStringParameters: {score, select: 'count', ExclusiveStartKey}})
      .then(res => {
        // console.log(res)
        if (res.LastEvaluatedKey) {
          return `${res.Count}+`;
        } else return res.Count;
      })
      .catch(err => {
        console.log(err);
      });
    }

    render() {

      return (
        <div className="HsiTitlePage">
          <h1>Hybris Site Identifier</h1>
          <table className="ScoreCount">
            <thead>
              <tr>
                <th>Score</th>
                {this.state.scoreCounts.map((score, index) => {
                  return <th key={`th${index}`}>{index}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Count</td>
                {this.state.scoreCounts.map((count, index) => {
                  return <td key={`td${index}`}>{count}</td>;
                })}
              </tr>
            </tbody>
          </table>
          <select value={this.props.chosenScores} onChange={this.handleScoreChange}>
            {this.state.scoreCounts.map((unused, index) => {
              return <option key={`dd${index}`} value={index}>{index}</option>;
            })}
          </select>
                Page: <input value={this.state.pageToChoose} onChange={this.handlePageChange}/>
          <button onClick={this.handleUpdatePage}>Submit</button>
        </div>
      );

    };

    handleScoreChange = e => {
      this.props.updateScore(e.target.value);
    }

    handlePageChange = e => {
      this.setState({pageToChoose: e.target.value});
    }

    handleUpdatePage = () => {
      this.props.updatePage(this.state.pageToChoose);
    }

};

export default HsiTitle;


// WEBPACK FOOTER //
// ./src/components/content/hybrisSiteIdentifier/hsiTitle/hsiTitle.js